import { isCustomerFeatureEnabled } from 'src/data/customer';
import { BE_CUSTOMER_FEATURES } from 'src/lib/featureFlags';
import { useCurrentCustomer } from 'src/store/customer';

export const useCustomerImageGenerationSupported = () => {
  const currentCustomer = useCurrentCustomer();
  return isCustomerFeatureEnabled(currentCustomer, BE_CUSTOMER_FEATURES.supportImageGeneration);
};
